import { Form, Modal, ModalProps, notification, Select, Typography } from 'antd'
import React from 'react'
import { FormItem } from '../../components/form-item'
import { useTranslation } from 'react-i18next'
import { Company } from '../company'
import useForm from '../../hooks/use-form'
import { useSendInvitation } from '../../invitation/hooks'

type CampaignCreateModalProps = {
    companyId?: Company['id']
} & ModalProps

export function CompanyUserInviteModal({ companyId, ...rest }: CampaignCreateModalProps) {
    const { t } = useTranslation()

    const mutation = useSendInvitation(companyId)

    const formProps = useForm({
        mutation,
        onSuccess: () => {
            formProps.form.resetFields()
            notification.success({
                message: t('Invitation sent'),
            })
            rest?.onCancel?.({} as never)
        },
    })

    return (
        <Modal
            {...rest}
            title={t('Invite colleagues')}
            onOk={() => formProps.form.submit()}
            okText={t('Invite')}
            okButtonProps={{
                loading: mutation.isPending,
            }}
        >
            <Typography.Text className="mb-4 block">
                {t(
                    'Enter the email of your colleagues you want to invite to join your company, They will receive an invitation email with instructions to join'
                )}
            </Typography.Text>
            <Form
                layout="vertical"
                {...formProps}
            >
                <FormItem
                    label={t('Email')}
                    name="emails"
                    required
                >
                    <Select
                        mode="tags"
                        open={false}
                        suffixIcon={<></>}
                        tokenSeparators={[',', ' ']}
                        placeholder={t('Enter colleague emails')}
                    />
                </FormItem>
            </Form>
        </Modal>
    )
}
